import { createSlice } from "@reduxjs/toolkit";

const loaderSlice = createSlice({
    name : 'loader',
    initialState : {
        LinearLoader : {
            show : false
        }
    },

    reducers : {
        toggleLinearLoader(state, data) {
            state.LinearLoader.show = data.payload;
        }
    }
});

export default loaderSlice.reducer;
export const { 
    toggleLinearLoader
} = loaderSlice.actions;